module.exports = __webpack_public_path__ + "img/sold-out.d6e7b434.png";